import { atom } from 'recoil'

export const medicalSupplyDateFilterState = atom<Date>({
  key: 'medicalSupplyDateFilterState',
  default: new Date(),
})

export const medicalSupplyTableDateFilterState = atom<Date | undefined>({
  key: 'medicalSupplyTableDateFilterState',
  default: undefined,
})

export const selectedRecordMedicineState = atom<string>({
  key: 'selectedRecordMedicineState',
  default: '',
})

export const selectedMedicineIdState = atom<number | undefined>({
  key: 'selectedMedicineIdState',
  default: undefined,
})
